/**
 * @generated SignedSource<<44a9bded719987e0a198376ee810243b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateVideoInput = {
  clientMutationId?: string | null | undefined;
  public?: boolean | null | undefined;
  videoId?: string | null | undefined;
  videoRawId?: number | null | undefined;
};
export type VideoAnswersField_UpdateVideoMutation$variables = {
  input: UpdateVideoInput;
};
export type VideoAnswersField_UpdateVideoMutation$data = {
  readonly updateVideo: {
    readonly video: {
      readonly id: string;
      readonly public: boolean;
      readonly user: {
        readonly " $fragmentSpreads": FragmentRefs<"VideoAnswersField_User">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type VideoAnswersField_UpdateVideoMutation = {
  response: VideoAnswersField_UpdateVideoMutation$data;
  variables: VideoAnswersField_UpdateVideoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "public",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoAnswersField_UpdateVideoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateVideoPayload",
        "kind": "LinkedField",
        "name": "updateVideo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "VideoAnswersField_User"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VideoAnswersField_UpdateVideoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateVideoPayload",
        "kind": "LinkedField",
        "name": "updateVideo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Video",
                    "kind": "LinkedField",
                    "name": "answers",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Question",
                        "kind": "LinkedField",
                        "name": "question",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rawId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d099d35195576ba83106bcc04f250e90",
    "id": null,
    "metadata": {},
    "name": "VideoAnswersField_UpdateVideoMutation",
    "operationKind": "mutation",
    "text": "mutation VideoAnswersField_UpdateVideoMutation(\n  $input: UpdateVideoInput!\n) {\n  updateVideo(input: $input) {\n    video {\n      id\n      public\n      user {\n        ...VideoAnswersField_User\n        id\n      }\n    }\n  }\n}\n\nfragment VideoAnswersField_User on User {\n  answers {\n    id\n    url\n    public\n    question {\n      rawId\n      title\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3648bf4c31340a50292c45dddb4d77b8";

export default node;
